module.exports = __webpack_public_path__ + "media/images/tumbler-1fa98bee386f72e4feb06c47a1589a53.jpeg";